import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const CaretRight = (props: IconProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M15.4992 11.2998L9.89922 5.5998C9.49922 5.1998 8.89922 5.1998 8.49922 5.5998C8.09922 5.9998 8.09922 6.5998 8.49922 6.9998L13.3992 11.8998L8.49922 16.7998C8.29922 16.9998 8.19922 17.1998 8.19922 17.4998C8.19922 18.0998 8.59922 18.4998 9.19922 18.4998C9.49922 18.4998 9.69922 18.3998 9.89922 18.1998L15.5992 12.4998C15.8992 12.2998 15.8992 11.6998 15.4992 11.2998Z"
      fill="#0188D0"
    />
  </svg>
)

export default CaretRight
